"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringUtils = void 0;
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
var string_1 = require("./publicInterface/shared/string");
var StringUtils = /** @class */ (function () {
    function StringUtils() {
        var _this = this;
        this.isValidEmail = string_1.isValidEmail;
        this.isInt = function (value) { return Number.isInteger(value); };
        this.isFloat = function (value) { return !!(value % 1); };
        this.toInt = function (value) { return parseInt(value); };
        this.toFloat = function (value) { return parseFloat(value); };
        this.containsStr = function (str, subStr) { return str && str.includes(subStr); };
        this.truncate = function (str, maxWidth) { return str && (maxWidth < str.length ? str.substring(0, maxWidth - 3) + '...' : str); };
        this.oneNullOneGiven = function (strOne, strTwo) { return (strOne === null && strTwo !== null) || (strOne !== null && strTwo === null); };
        this.bothNull = function (strOne, strTwo) { return strOne === null && strTwo === null; };
        this.bothNotNull = function (strOne, strTwo) { return strOne !== null && strTwo !== null; };
        this.isBlank = function (str) { return (str === null ? true : str.trim() === '' ? true : false); };
        this.isNotBlank = function (str) { return (str === null ? false : str.trim() === '' ? false : true); };
        this.isEmpty = function (str) { return !str; };
        this.isEmptyStr = function (str) { return !str; };
        this.isNotEmpty = function (str) { return (str === null ? false : str.length > 0 ? true : false); };
        this.diffNonBlankStr = function (strOne, strTwo) {
            return !_this.isBlank(strOne) && !_this.isBlank(strTwo) && strOne.toLowerCase() !== strTwo.toLowerCase();
        };
        this.sameNonBlankStr = function (strOne, strTwo) {
            return !_this.isBlank(strOne) && !_this.isBlank(strTwo) && strOne.toLowerCase() === strTwo.toLowerCase();
        };
        this.diffNonEmptyStr = function (strOne, strTwo) {
            return !_this.isEmpty(strOne) && !_this.isEmpty(strTwo) && strOne.toLowerCase() !== strTwo.toLowerCase();
        };
        this.sameNonEmptyStr = function (strOne, strTwo) {
            return !_this.isEmpty(strOne) && !_this.isEmpty(strTwo) && strOne.toLowerCase() === strTwo.toLowerCase();
        };
        this.diffNonBlankStrWithCase = function (strOne, strTwo) { return !_this.isBlank(strOne) && !_this.isBlank(strTwo) && strOne !== strTwo; };
        this.sameNonBlankStrWithCase = function (strOne, strTwo) { return !_this.isBlank(strOne) && !_this.isBlank(strTwo) && strOne === strTwo; };
        this.diffNonEmptyStrWithCase = function (strOne, strTwo) { return !_this.isEmpty(strOne) && !_this.isEmpty(strTwo) && strOne !== strTwo; };
        this.sameNonEmptyStrWithCase = function (strOne, strTwo) { return !_this.isEmpty(strOne) && !_this.isEmpty(strTwo) && strOne === strTwo; };
        this.toProperCase = function (str) {
            if (!str) {
                return str;
            }
            return str
                .toLowerCase()
                .split(' ')
                .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
                .join(' ');
        };
        this.string = function (input) { return String(input); };
        this.slice = function (str, ix1, ix2) { return str.slice(ix1, ix2); };
    }
    return StringUtils;
}());
exports.StringUtils = StringUtils;
//# sourceMappingURL=StringUtils.js.map